"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Log = exports.LogLevel = exports.DEFAULT_PROFILE_UUID = void 0;
exports.DEFAULT_PROFILE_UUID = "unknown";
var LogLevel;
(function (LogLevel) {
    LogLevel["ERROR"] = "ERROR";
    LogLevel["INFO"] = "INFO";
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["WARN"] = "WARN";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
class Log {
    static setProfile(profileUUID) {
        Log.profileUUID = profileUUID;
    }
    static setAppName(name) {
        Log.appName = name;
    }
    static setExtraData(object) {
        Log.extraData = Object.assign(Object.assign({}, Log.extraData), object);
    }
    static addLogger(name, logger) {
        Log.externalLogger[name] = logger;
    }
    static setVerbosity(level) {
        Log.verbosity = level;
    }
    static warn(text, ...additionalArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            Log.shipLogsOut(LogLevel.WARN, text, additionalArgs);
        });
    }
    static info(text, ...additionalArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            Log.shipLogsOut(LogLevel.INFO, text, additionalArgs);
        });
    }
    static error(text, ...additionalArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            Log.shipLogsOut(LogLevel.ERROR, text, additionalArgs);
        });
    }
    static debug(text, ...additionalArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            Log.shipLogsOut(LogLevel.DEBUG, text, additionalArgs);
        });
    }
    static output(level, text, additionalText) {
        let sendLog = console.log;
        switch (level) {
            default:
            case LogLevel.ERROR:
                sendLog = console.error;
                break;
            case LogLevel.DEBUG:
                sendLog = console.debug;
                break;
            case LogLevel.INFO:
                sendLog = console.info;
                break;
            case LogLevel.WARN:
                sendLog = console.warn;
                break;
        }
        if (additionalText) {
            sendLog(text, additionalText);
        }
        else {
            sendLog(text);
        }
    }
    static getValueVebosity(level) {
        switch (level) {
            default:
            case LogLevel.ERROR:
                return 4;
            case LogLevel.WARN:
                return 3;
            case LogLevel.INFO:
                return 2;
            case LogLevel.DEBUG:
                return 1;
        }
    }
    static checkShouldLogLocally(logLevel) {
        const ourVerbosity = Log.getValueVebosity(Log.verbosity);
        const logVerbosity = Log.getValueVebosity(logLevel);
        return logVerbosity >= ourVerbosity;
    }
    static shipLogsOut(logLevel, message, meta) {
        return __awaiter(this, void 0, void 0, function* () {
            if (Log.checkShouldLogLocally(logLevel)) {
                Log.output(logLevel, message, meta.length > 0 ? `: ${meta.map((i) => JSON.stringify(i)).join(", ")}` : undefined);
            }
            for (const loggerKey of Object.keys(Log.externalLogger)) {
                const logger = Log.externalLogger[loggerKey];
                logger(logLevel, message, meta.length > 0 ? `: ${meta.map((i) => JSON.stringify(i)).join(", ")}` : undefined);
            }
        });
    }
}
exports.Log = Log;
Log.verbosity = LogLevel.DEBUG;
Log.profileUUID = exports.DEFAULT_PROFILE_UUID;
Log.extraData = {};
Log.externalLogger = {};
//# sourceMappingURL=Log.js.map